import {ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, input} from '@angular/core';
import { TFormState } from '../../../../models/forms.model';
import { STEPS_STYLING_MAP } from '../../models/contract-styling-consts';
import { ContractStepModel } from '../../../../models/contract.model';

@Component({
    selector: 'app-contract-step-name-edit',
    templateUrl: './contract-step-name-edit.component.html',
    styleUrl: './contract-step-name-edit.component.scss',
    changeDetection:ChangeDetectionStrategy.OnPush,
 
})
export class AppContractStepNameComponent {
  @Input() contractStep!: ContractStepModel
    public stepsStylingMap = STEPS_STYLING_MAP
    public formState:TFormState = 'Default'
    constructor(
    ) { }
}